import React, { useState } from "react";
import banner from "../assets/skodakodiaq.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Skoda = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "skodaLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Skoda Kodiaq RS",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      {/* HERO */}
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={banner} alt="Skoda Kodiaq RS" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* ABOUT */}
      <section className="about-gravite">
       <h2>Experience the New Škoda Kodiaq RS</h2>

<p>
  The all-new Škoda Kodiaq RS is the most powerful and fastest-accelerating
  Škoda ever launched in India. Powered by a 2.0-litre TSI turbo-petrol
  engine producing 265 hp and 400 Nm of torque, the SUV combines thrilling
  performance with premium comfort. Featuring adaptive suspension, all-wheel
  drive, luxurious interiors, advanced safety technologies, and distinctive
  RS styling, the Kodiaq RS is designed for enthusiasts who want performance
  without compromising practicality.
</p>
      </section>

      {/* TABLE */}
      <section className="tech-data">
        <h2>Technical Data for the Skoda Kodiaq RS</h2>

        <table>
        <thead>
<tr>
  <th>Specification</th>
  <th colSpan="4">Škoda Kodiaq RS</th>
</tr>
</thead>

    <tbody>

<tr>
  <td>Ex-Showroom Price</td>
  <td colSpan="4">₹66.99 Lakh</td>
</tr>

<tr>
  <td>Engine</td>
  <td colSpan="4">2.0L TSI Turbo Petrol (EA888)</td>
</tr>

<tr>
  <td>Power</td>
  <td colSpan="4">265 hp</td>
</tr>

<tr>
  <td>Torque</td>
  <td colSpan="4">400 Nm</td>
</tr>

<tr>
  <td>Transmission</td>
  <td colSpan="4">7-Speed DSG Automatic</td>
</tr>

<tr>
  <td>Drive Type</td>
  <td colSpan="4">All-Wheel Drive (AWD)</td>
</tr>

<tr>
  <td>0-100 km/h</td>
  <td colSpan="4">6.3 Seconds</td>
</tr>

<tr>
  <td>Suspension</td>
  <td colSpan="4">Adaptive DCC Plus (15 Modes)</td>
</tr>

<tr>
  <td>Wheels</td>
  <td colSpan="4">20-inch Alloy Wheels</td>
</tr>

<tr>
  <td>Infotainment</td>
  <td colSpan="4">12.9-inch Touchscreen</td>
</tr>

<tr>
  <td>Instrument Cluster</td>
  <td colSpan="4">10.25-inch Digital Cockpit</td>
</tr>

<tr>
  <td>Audio System</td>
  <td colSpan="4">13-Speaker Canton Premium Audio</td>
</tr>

<tr>
  <td>Safety</td>
  <td colSpan="4">
    9 Airbags, 360° Camera, ADAS
  </td>
</tr>

</tbody>
        </table>
      </section>

      {/* CUSTOM POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Skoda;